import submitFeedback from 'src/graphql/mutations/submitFeedback';

import post from './shared/post';

export default {
  submitFeedback(values) {
    return post(values, submitFeedback);
  },
};
